import React from 'react';
import { Circle as RCProgressCircle } from 'rc-progress';
import { withNativeProps } from '../../utils/native-props';
import { withDefaultProps } from '../../utils/with-default-props';
import { convertPx } from '../../utils/convert-px';
var classPrefix = "adm-progress";
export var ProgressCircle = withDefaultProps({
  percent: 0,
  strokeColor: '#1677FF'
})(function (props) {
  var strokeWidth = props.strokeWidth,
      size = props.size;

  if (strokeWidth === undefined) {
    strokeWidth = convertPx(6);
  }

  if (size === undefined) {
    size = convertPx(50);
  }

  var contentStyle = {
    width: size + "px",
    height: size + "px"
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-circle-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-circle-content",
    style: contentStyle
  }, /*#__PURE__*/React.createElement(RCProgressCircle, {
    prefixCls: classPrefix,
    percent: props.percent,
    strokeWidth: strokeWidth,
    trailWidth: strokeWidth,
    trailColor: '#E5E5E5',
    strokeColor: props.strokeColor
  }), /*#__PURE__*/React.createElement("div", {
    className: classPrefix + "-circle-info"
  }, props.children))));
});